import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormSectionWrapper from "../../../Components/ProForms/FormSectionWrapper";
import ProFormsLayout from "../../../Components/ProForms/ProFormsLayout";
import { useForm } from "react-hook-form";
import { STAUTES } from "../../../../utils/constant";
import ProTextInput from "../../../Components/Inputs/TextField";
import ProSelectField from "../../../Components/Inputs/SelectField";
import ProMobileField from "../../../Components/Inputs/MobileField";
import ProEmailField from "../../../Components/Inputs/EmailField";
import ProDateField from "../../../Components/Inputs/DateField";
import ProCurrencyField from "../../../Components/Inputs/CurrencyField";
import ProFileUploadField from "../../../Components/Inputs/FileUploadField";
import ProSSNField from "../../../Components/Inputs/SSNField";
import ProCheckbox from "../../../Components/Inputs/CheckboxField";
import InputWrapper from "../../../Components/Inputs/InputWrapper";
import {
  changeMode,
  changeModeForField,
  convertResponseDate,
  prepareDefaultValues,
  prepareInitialConfig,
  employeeProfileFormName,
  convertFileToBase64Model,
  formatPayloadDate,
  fieldTruePermission,
  isDateApprenticeshipBeginsInRange
} from "../../../../utils/formHelper";
import { Box } from "@mui/material";
import {
  // V2 endpoints
  GET_ALL_EMPLOYEES_V2,
  SEND_APPRENTICE_APPLICATION_DOCUMENT,
  GET_PROJECT_BY_EMPLOYEE,
  // Dropdown endpoints
  GET_ALL_LANGUAGE_TYPES,
  GET_ALL_MANAGER_TYPES,
  GET_ALL_NOTIFICATION_TYPES,
  GET_ALL_EMPLOYEE_STATUS_TYPES,
  GET_ALL_EMPLOYEE_TERM,
  GET_ALL_FRINGE_PAYMENT_METHOD,
  GET_ALL_ETHNICITY_TYPES,
  GET_ALL_VETERAN_STATUS_TYPES,
  GET_ALL_RACE_TYPES,
  GET_ALL_EDUCATION_LEVEL_TYPES,
  GET_ALL_DISABILITY_TYPES,
  GET_ALL_APPRENTICE_STATUS_TYPES,
  GET_ALL_CAREER_CONNECTION_TYPES,
  RAP_INFOS_DROPDOWNS,
  GET_CLIENT_FRINGE_BENEFITS
} from "../../../../utils/services/apiPath";
import { errorToast, successToast } from "../../../../utils/toastHelper";
import { getApi, postApi, putApi } from "../../../../utils/services";
import Loading from "../../../Components/Loading";
import {
  defaultDropdownConfig,
  employmentStatusOptions,
  sexOptions,
  transFormModalData,
  employeeTypeOptions,
  apprenticeProspectStatusOptions
} from "../../../../utils/dropdownHelper";
import ProMultiSelectSelectField from "../../../Components/Inputs/MultiSelectField";
import { employeesProfilePermissionSelector, employeesPermissionSelector } from "../../../store/features/permissions/permissionsSlice";
import usePermission from "../../../../utils/customHooks/usePermission";
import ZipField from "../../../Components/Inputs/ZipField";
import { useSelector } from "react-redux";
import { userSelector } from "../../../store/features/auth/authSlice";
import { EmployeeProfileFormConfig } from "../EmployeeData";
import ConfirmationModal from "../../../Components/ConfirmationModal";
import ToggleField from "../../../Components/Inputs/ToggleButton";
import { fringeBenefitTypes } from "../../../Constants/DropdownTypes";

const isOptionNotSelected = (opt, selectedList) => !(Array.isArray(selectedList) && selectedList.some(item => item.value === opt.value));

export default function EmployeeProfile() {
  const user = useSelector(userSelector);
  const isEmployeeOnRAP360Program = user?.apprenticeManagementType === "Apprenticeship 360";
  const [formConfig, setFormConfig] = useState(prepareInitialConfig(EmployeeProfileFormConfig));
  const [employeeProfileData, setEmployeeProfileData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [languageType, setLanguageType] = useState([]);
  const [notificationType, setNotificationType] = useState([]);
  const [employeeStausType, setEmployeeStausType] = useState([]);
  const [employeeTermType, setEmployeeTermType] = useState([]);
  const [managerType, setManagerType] = useState([]);
  const [fringePaymentMethod, setFringePaymentMethod] = useState([]);
  const [ethiniCity, setEthiniCity] = useState([]);
  const [veteranStatus, setVeteranStatus] = useState([]);
  const [race, setRace] = useState([]);
  const [educationLevel, setEducationLevel] = useState([]);
  const [disability, setDisability] = useState([]);
  const [apprenticeshipsProgram, setApprenticeshipsProgram] = useState([]);
  const [apprenticeStatus, setApprenticeStatus] = useState([]);
  const [careerConnections, setCareerConnections] = useState([]);
  const [status, setStatus] = useState(STAUTES.IDLE);
  const [healthInsuranceOptions, setHealthInsuranceOptions] = useState([]);
  const [retirementPensionOptions, setRetirementPensionOptions] = useState([]);
  const [fringeBenefitCheckbox, setFringeBenefitCheckbox] = useState([]);
  const [fringeBenefitDropdowns, setFringeBenefitDropdowns] = useState([]);
  const [employeeTypeChangeModalConfig, setEmployeeTypeChangeModalConfig] = useState({ show: false, message: "" });
  const { handleSubmit, control, setValue, watch } = useForm({
    defaultValues: prepareDefaultValues(EmployeeProfileFormConfig),
    mode: "onBlur",
    reValidateMode: "onBlur"
  });
  const isEditModeOn = useMemo(() => Object.values(formConfig).some(({ mode }) => mode === "edit"), [formConfig]);
  const {
    "Basic Information": employeeBasicInfo,
    "Apprentice Information": employeeApprenticeInfo,
    "Address Information": employeeAddressInfo,
    "Mailing Address Inforamtion": employeeMailingAddressInfo,
    "Additional Information": employeeAdditionalInfo
  } = usePermission(employeesProfilePermissionSelector, employeeProfileFormName);
  const { subModulePermissions } = useSelector(employeesPermissionSelector);
  const profilePermission = subModulePermissions?.EMPLOYEES_PROFILE?.canView;
  const [isSaving, setIsSaving] = useState(false);
  const [isApprentice, setIsApprentice] = useState(false);
  const employeeType = watch("employeeTypeId");
  const healthInsurance = watch("healthInsuranceId");
  const retirementPension = watch("retirementPensionId");
  const isUnion = watch("isUnion");
  const ssn = watch("ssn");

  const navigate = useNavigate();
  const { id } = useParams();
  const isAddMode = useMemo(() => id === "add", [id]);
  const backAction = () => navigate("/employees");

  const onEdit = () => setFormConfig(changeMode("edit"));

  const onCancel = () => (isAddMode ? navigate("/employees") : setFormConfig(changeMode()));

  const handleReadValueClick = name => setFormConfig(changeModeForField(name, "edit"));

  const sendApprenticeApplicationDocument = async (employeeGuid, email) => {
    if (employeeType !== 4) {
      return;
    }

    const { error } = await postApi(`${SEND_APPRENTICE_APPLICATION_DOCUMENT}?employeeGuid=${employeeGuid}`);
    if (error) return errorToast(error);
    successToast(`An email of the onboarding document was sent to ${email}.`);
  };

  const showEmployeeTypeChangeWarning = async prevType => {
    let message = "Changing the employee type may impact assigned project. Are you sure you want to change?";
    try {
      if (prevType === 1 || prevType === 2) {
        setStatus(STAUTES.LOADING);
        const res = await getApi(`${GET_PROJECT_BY_EMPLOYEE}/${id}`);
        setStatus(STAUTES.IDLE);
        const key = prevType === 2 ? "mentors" : "apprentices";
        if (Array.isArray(res[key]) && res[key].length) {
          message = `This employee is currently assigned as a ${prevType === 2 ? "mentor" : "apprentice"} in the following projects: ${res[key].join(
            ", "
          )}. Changing their employee type will remove them from these projects as a ${prevType === 2 ? "mentor" : "apprentice"}.`;
        }
      }
    } catch {
      // fallback to default message
    } finally {
      setEmployeeTypeChangeModalConfig({
        show: true,
        message
      });
    }
  };

  const onSubmit = async values => {
    if (isSaving) return;
    if (employeeType === 4) {
      values.apprenticeProspectStatusTypeId = 1;
    }

    values.isApprentice = employeeType === 1 || employeeType === 4;

    if (values.fringeRateAmount === undefined || values.fringeRateAmount === "") {
      values.fringeRateAmount = null;
    }

    if (!values.passEmployeeTypeCheck && employeeProfileData?.employeeTypeId && employeeProfileData?.employeeTypeId !== values?.employeeTypeId) {
      return showEmployeeTypeChangeWarning(employeeProfileData?.employeeTypeId);
    }

    // Date Apprenticeship Begins range validation
    if (values.dateApprenticeshipBegins && !isDateApprenticeshipBeginsInRange(values.dateApprenticeshipBegins)) {
      return errorToast("The Date Apprenticeship Begins must be within the allowed range — no earlier than 5 years before today and no later than 20 years after today.");
    }

    if ((values.employeeTypeId === 1 || values.employeeTypeId === 4) && !values.rapInfoId) {
      return errorToast("Apprenticeships Program is required!");
    }

    if (values.dateApprenticeshipBegins && !values.rapInfoId) {
      return errorToast("Apprenticeships Program is required when Date Apprenticeship Begins is set");
    }

    setIsSaving(true);
    setStatus(STAUTES.LOADING);

    try {
      let finalLast4SSN = "";

      if (values.ssn && values.ssn.trim() !== "") {
        finalLast4SSN = String(values.ssn).replace(/\D/g, "").slice(-4);
      } else if (values.last4ofSSN && values.last4ofSSN.trim() !== "") {
        finalLast4SSN = String(values.last4ofSSN).replace(/\D/g, "").slice(-4);
      }

      values.last4ofSSN = finalLast4SSN;
      values.ssn = finalLast4SSN; 

      const base64ProfilePicture = await convertFileToBase64Model(values.profilePictureFile);
      const employeeFringeBenefit = convertToEmployeeFringeBenefitPayload();
      const { retirementPensionId, healthInsuranceId, ...payloadValues } = values;
      const payload = {
        ...payloadValues,
        apprenticeStatusTypeId: apprenticeStatus?.value,
        last4ofSSN: values.last4ofSSN,
        raceTypeId: values.raceTypeId?.map(({ value }) => value) || null,
        veteranStatusTypeId: values.veteranStatusTypeId?.map(({ value }) => value) || null,
        invitationVerificationCode: null,
        managerId: values.manager,
        languageTypeId: values.languageType,
        notificationTypeId: values.notificationType,
        fringePaymentMethodTypeId: values.fringePaymentMethodType,
        birthDate: formatPayloadDate(values.birthDate),
        startDate: formatPayloadDate(values.startDate),
        endDate: formatPayloadDate(values.endDate),
        dateApprenticeshipBegins: formatPayloadDate(values.dateApprenticeshipBegins),
        profileMediaModel: base64ProfilePicture || null,
        profilePicture: base64ProfilePicture?.base64String || null,
        employeeId: isAddMode ? null : id,
        employeeFringeBenefit: employeeFringeBenefit
      };
      
      // Use V2 API endpoints
      const response = isAddMode ? await postApi(GET_ALL_EMPLOYEES_V2, payload) : await putApi(`${GET_ALL_EMPLOYEES_V2}/${id}?portalType=1`, payload); // portalType=1 for Admin/Client Portal

      setIsSaving(false);
      setStatus(STAUTES.IDLE);
      
      if (response?.error) {
        return errorToast(typeof response.error === "string" ? response.error : "Failed to save employee");
      }

      successToast(`Employee ${isAddMode ? "Added" : "Updated"} Successfully`);
  
      await sendApprenticeApplicationDocument(id, values.email);
      setEmployeeProfileData(values);
      onCancel();
    } catch (error) {
      setIsSaving(false);
      setStatus(STAUTES.IDLE);
      console.error("Error saving employee:", error);
      errorToast(error.message || "Failed to save employee");
    }
  };

  const getDropdownOptionsByType = (type, fringeBenefitData) => {
    const section = fringeBenefitData.employeeFringeBenefitDropdownList?.find(item => item.fringeBenefitType === type);
    return (
      section?.employeeFringeBenefitAccounts?.map(account => ({
        value: account.fringeBenefitAccountId,
        label: account.planName
      })) || []
    );
  };

  const fetchFringeBenefits = async () => {
    const fringeBenefitData = await getApi(GET_CLIENT_FRINGE_BENEFITS);
    setHealthInsuranceOptions(getDropdownOptionsByType("Health Insurance", fringeBenefitData));
    setRetirementPensionOptions(getDropdownOptionsByType("Retirement/Pension", fringeBenefitData));
    setFringeBenefitDropdowns(fringeBenefitData?.employeeFringeBenefitDropdownList);
    setFringeBenefitCheckbox(fringeBenefitData?.employeeFringeBenefitSingle);
  };

  const handleCheckBoxChange = (e, index) => {
    const isChecked = e.target.checked;
    const updatedCheckboxes = [...fringeBenefitCheckbox];
    updatedCheckboxes[index].employeeFringeBenefitAccounts[0].isSelected = isChecked;
    setFringeBenefitCheckbox(updatedCheckboxes);
  };

  const handleHealthInsuranceSelect = selectedValue => {
    setFringeBenefitDropdowns(prev =>
      prev.map(item => {
        if (item.fringeBenefitType === fringeBenefitTypes.healthInsurance.label) {
          const updatedFringeBenefitDropdowns = item.employeeFringeBenefitAccounts.map(account => ({
            ...account,
            isSelected: account.fringeBenefitAccountId === selectedValue
          }));

          return {
            ...item,
            employeeFringeBenefitAccounts: updatedFringeBenefitDropdowns
          };
        }
        return item;
      })
    );
  };

  const handleRetirementPensionSelect = selectedValues => {
    const uniqueValues = Array.from(new Set(selectedValues?.map(opt => opt.value)));
    setFringeBenefitDropdowns(prev =>
      prev.map(item => {
        if (item.fringeBenefitType === fringeBenefitTypes.retirement.label) {
          const updatedFringeBenefitDropdowns = item.employeeFringeBenefitAccounts.map(account => ({
            ...account,
            isSelected: uniqueValues.includes(account.fringeBenefitAccountId)
          }));

          return {
            ...item,
            employeeFringeBenefitAccounts: updatedFringeBenefitDropdowns
          };
        }
        return item;
      })
    );
  };

  const convertToEmployeeFringeBenefitPayload = () => {
    const employeeFringeBenefit = [];
    fringeBenefitDropdowns.forEach(item => {
      item.employeeFringeBenefitAccounts.forEach(account => {
        const { planName, ...rest } = account;
        employeeFringeBenefit.push(rest);
      });
    });

    fringeBenefitCheckbox.forEach(item => {
      const { planName, ...rest } = item.employeeFringeBenefitAccounts[0];
      employeeFringeBenefit.push(rest);
    });

    return employeeFringeBenefit;
  };

  const getHealthInsuranceId = data => {
    const section = data?.find(item => item.fringeBenefitType === fringeBenefitTypes.healthInsurance.label);
    const selectedAccount = section?.employeeFringeBenefitAccounts?.find(account => account.isSelected);
    return selectedAccount?.fringeBenefitAccountId || null;
  };

  const getRetirementPensionIds = data => {
    const section = data?.find(item => item.fringeBenefitType === fringeBenefitTypes.retirement.label);
    return (
      section?.employeeFringeBenefitAccounts
        ?.filter(account => account.isSelected)
        ?.map(account => ({
          value: account.fringeBenefitAccountId,
          label: account.planName
        })) || []
    );
  };

  const getEmployeeProfileData = async id => {
    setFormConfig(changeMode("read"));
    setIsLoading(true);

    try {
      // Use V2 API endpoint with portalType=1 for Admin/Client Portal
      const response = await getApi(`${GET_ALL_EMPLOYEES_V2}/${id}?portalType=1`);

      // Handle both wrapped and unwrapped responses
      const employee = response?.data || response;

      if (!employee) {
        setIsLoading(false);
        return errorToast("Failed to load employee data");
      }

      const {
        employeeStatusType,
        employeeStatusTypeId,
        ethnicityTypeModel,
        veteranStatusTypeModel,
        raceTypeModel,
        educationLevelTypeModel,
        disabilityTypeModel,
        rapInfoModel,
        careerConnectionTypeModel,
        apprenticeStatusTypeModel,
        managerIds,
        languageTypeIds,
        notificationTypeIds,
        employmentTermTypeIds,
        fringePaymentMethodTypeIds,
        startDate,
        endDate,
        birthDate,
        dateApprenticeshipBegins,
        profileMediaModel
      } = employee;

      const employeeStatus = {
        label: employeeStatusType,
        value: employeeStatusTypeId
      };

      const dataNew = {
        ...employee,
        last4ofSSN: employee.last4ofSSN,
        birthDate: convertResponseDate(birthDate),
        dateApprenticeshipBegins: convertResponseDate(dateApprenticeshipBegins),
        startDate: convertResponseDate(startDate),
        endDate: convertResponseDate(endDate),
        veteranStatusTypeId: veteranStatusTypeModel,
        raceTypeId: raceTypeModel,
        profilePicture: profileMediaModel?.path,
        healthInsuranceId: getHealthInsuranceId(employee?.employeeFringeBenefits?.employeeFringeBenefitDropdownList),
        retirementPensionId: getRetirementPensionIds(employee?.employeeFringeBenefits?.employeeFringeBenefitDropdownList),
        ...transFormModalData({
          employeeStatusTypeGuid: employeeStatus,
          ethnicityTypeId: ethnicityTypeModel,
          educationLevelTypeId: educationLevelTypeModel,
          rapInfoId: rapInfoModel,
          disabilityTypeId: disabilityTypeModel,
          careerConnectionTypeId: careerConnectionTypeModel,
          apprenticeStatusTypeId: apprenticeStatusTypeModel,
          fringePaymentMethodType: fringePaymentMethodTypeIds,
          manager: managerIds,
          languageType: languageTypeIds,
          notificationType: notificationTypeIds,
          employmentTermTypeId: employmentTermTypeIds
        })
      };
      setFringeBenefitCheckbox(employee?.employeeFringeBenefits?.employeeFringeBenefitSingle);
      setEmployeeProfileData(dataNew);
      Object.keys(formConfig).forEach(field => setValue(field, dataNew[field]));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching employee data:", error);
      errorToast(error.message || "Failed to load employee data");
    }
  };

  // Combined fetch function to optimize dropdown fetching
  const fetchAllDropdowns = async () => {
    try {
      const [
        languageTypeRes,
        notificationTypeRes,
        employeeStatusTypeRes,
        employeeTermTypeRes,
        fringePaymentMethodRes,
        managerTypeRes,
        ethnicityTypesRes,
        veteranStatusTypesRes,
        raceTypesRes,
        educationLevelTypesRes,
        disabilityTypesRes,
        rapInfoRes,
        apprenticeStatusTypesRes,
        careerConnectionTypesRes
      ] = await Promise.all([
        postApi(GET_ALL_LANGUAGE_TYPES, defaultDropdownConfig),
        postApi(GET_ALL_NOTIFICATION_TYPES, defaultDropdownConfig),
        postApi(GET_ALL_EMPLOYEE_STATUS_TYPES, defaultDropdownConfig),
        postApi(GET_ALL_EMPLOYEE_TERM, defaultDropdownConfig),
        postApi(GET_ALL_FRINGE_PAYMENT_METHOD, defaultDropdownConfig),
        postApi(GET_ALL_MANAGER_TYPES, defaultDropdownConfig),
        postApi(GET_ALL_ETHNICITY_TYPES, defaultDropdownConfig),
        postApi(GET_ALL_VETERAN_STATUS_TYPES, defaultDropdownConfig),
        postApi(GET_ALL_RACE_TYPES, defaultDropdownConfig),
        postApi(GET_ALL_EDUCATION_LEVEL_TYPES, defaultDropdownConfig),
        postApi(GET_ALL_DISABILITY_TYPES, defaultDropdownConfig),
        getApi(RAP_INFOS_DROPDOWNS, defaultDropdownConfig),
        postApi(GET_ALL_APPRENTICE_STATUS_TYPES, defaultDropdownConfig),
        postApi(GET_ALL_CAREER_CONNECTION_TYPES, defaultDropdownConfig)
      ]);

      setLanguageType((languageTypeRes.data || []).map(item => ({ label: item.languageType, value: item.languageTypeId })));
      setNotificationType((notificationTypeRes.data || []).map(item => ({ label: item.notificationType, value: item.notificationTypeId })));
      setEmployeeStausType((employeeStatusTypeRes.data || []).map(item => ({ label: item.employeeStatusType, value: item.employeeStatusTypeId })));
      setEmployeeTermType((employeeTermTypeRes.data || []).map(item => ({ label: item.employmentTermType, value: item.employmentTermTypeId })));
      setFringePaymentMethod(
        (fringePaymentMethodRes.data || []).map(item => ({ label: item.fringePaymentMethodType, value: item.fringePaymentMethodTypeId }))
      );
      setManagerType((managerTypeRes.data || []).map(item => ({ label: item.employeeName, value: item.employeeId })));
      setEthiniCity(ethnicityTypesRes.data || []);
      setVeteranStatus(veteranStatusTypesRes.data || []);
      setRace(raceTypesRes.data || []);
      setEducationLevel(educationLevelTypesRes.data || []);
      setDisability(disabilityTypesRes.data || []);

      // rapInfoRes is from getApi so needs different structure
      setApprenticeshipsProgram(
        (rapInfoRes.data || []).map(item => ({
          label: item.label ?? item.name,
          value: item.value ?? item.rapInfoId
        }))
      );

      setApprenticeStatus(apprenticeStatusTypesRes.data || []);
      setCareerConnections(careerConnectionTypesRes.data || []);
    } catch (error) {
      // Log and optionally show a toast if you want unified error handling
      console.error("Failed to fetch dropdown data:", error);
      errorToast(error.message || "Failed to load dropdown data");
    }
  };

  useEffect(() => {
    fetchAllDropdowns();
    fetchFringeBenefits();
    if (isAddMode) onEdit();
    if (!isAddMode) getEmployeeProfileData(id);
  }, [id]);

  useEffect(() => {
    setIsApprentice(employeeType === 1 || employeeType === 4);
  }, [employeeType]);

  useEffect(() => {
    handleHealthInsuranceSelect(healthInsurance);
  }, [healthInsurance]);

  useEffect(() => {
    handleRetirementPensionSelect(retirementPension);
  }, [retirementPension]);

  const defaultFormProps = { control, formValues: employeeProfileData, isAddMode, handleReadValueClick };
  return (
    <div className="partner-profile">
      <ProFormsLayout
        status={status}
        backAction={backAction}
        title={`${isAddMode ? "Add" : "Edit"} Employee`}
        backLabel="Go Back to All Employees"
        beingEdited={isEditModeOn}
        onEdit={onEdit}
        isSaving={isSaving}
        canView={profilePermission}
        hideEdit={
          !(
            employeeBasicInfo.canEdit ||
            employeeApprenticeInfo.canEdit ||
            employeeAddressInfo.canEdit ||
            employeeMailingAddressInfo.canEdit ||
            employeeAdditionalInfo.canEdit
          )
        }
        onCancel={onCancel}
        onSave={handleSubmit(onSubmit)}
      >
        {!isLoading ? (
          <>
            {employeeBasicInfo.canView && (
              <FormSectionWrapper title={"BASIC INFORMATION"}>
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.employeeStatusTypeGuid}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.employeeStatusTypeGuid.perKey]}
                  options={employeeStausType}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.internalEmployeeId}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.internalEmployeeId.perKey]}
                />
                <ProTextInput {...defaultFormProps} {...formConfig.jobTitle} permission={employeeBasicInfo.fieldPerObj[formConfig.jobTitle.perKey]} />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.firstName}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.firstName.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.middleName}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.middleName.perKey]}
                />
                <ProTextInput {...defaultFormProps} {...formConfig.lastName} permission={employeeBasicInfo.fieldPerObj[formConfig.lastName.perKey]} />
                <ProMobileField
                  {...defaultFormProps}
                  {...formConfig.cellPhone}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.cellPhone.perKey]}
                />
                <ProMobileField
                  {...defaultFormProps}
                  {...formConfig.officePhone}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.officePhone.perKey]}
                />
                <ProMobileField
                  {...defaultFormProps}
                  {...formConfig.whatsApp}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.whatsApp.perKey]}
                />
                <ProEmailField {...defaultFormProps} {...formConfig.email} permission={employeeBasicInfo.fieldPerObj[formConfig.email.perKey]} />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.department}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.department.perKey]}
                />
                {(ssn && (
                  <ProSSNField
                    {...defaultFormProps}
                    {...formConfig.ssn}
                    permission={employeeBasicInfo.fieldPerObj[formConfig.ssn.perKey]}
                    isLast4={false}
                  />
                )) || (
                  <ProSSNField
                    {...defaultFormProps}
                    {...formConfig.last4ofSSN}
                    permission={employeeBasicInfo.fieldPerObj[formConfig.last4ofSSN.perKey]}
                    isLast4={true}
                  />
                )}
                <ProDateField
                  {...defaultFormProps}
                  {...formConfig.birthDate}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.birthDate.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.sex}
                  options={sexOptions}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.sex.perKey]}
                />
                <ProFileUploadField
                  {...defaultFormProps}
                  {...formConfig.profilePictureFile}
                  inputProps={{ accept: "image/*" }}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.profilePictureFile.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.yearsOfExperience}
                  permission={employeeBasicInfo.fieldPerObj[formConfig.yearsOfExperience.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.employeeTypeId}
                  options={employeeTypeOptions}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.ethnicityTypeId.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.apprenticeProspectStatusTypeId}
                  options={apprenticeProspectStatusOptions}
                  {...(isEmployeeOnRAP360Program ? { mode: "read" } : {})}
                  // TODO: Do the permissions for this
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.ethnicityTypeId.perKey]}
                />
              </FormSectionWrapper>
            )}
            {isApprentice && employeeApprenticeInfo.canView && (
              <FormSectionWrapper title={"APPRENTICE INFORMATION"}>
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.ethnicityTypeId}
                  options={ethiniCity}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.ethnicityTypeId.perKey]}
                />
                <ProMultiSelectSelectField
                  {...defaultFormProps}
                  {...formConfig.veteranStatusTypeId}
                  options={veteranStatus}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.veteranStatusTypeId.perKey]}
                />
                <ProMultiSelectSelectField
                  {...defaultFormProps}
                  {...formConfig.raceTypeId}
                  options={race}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.raceTypeId.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.educationLevelTypeId}
                  options={educationLevel}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.educationLevelTypeId.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.disabilityTypeId}
                  options={disability}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.disabilityTypeId.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.employmentStatus}
                  options={employmentStatusOptions}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.employmentStatus.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.rapInfoId}
                  options={apprenticeshipsProgram}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.rapInfoId.perKey]}
                />
                <ProDateField
                  {...defaultFormProps}
                  {...formConfig.dateApprenticeshipBegins}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.dateApprenticeshipBegins.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.careerConnectionTypeId}
                  options={careerConnections}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.careerConnectionTypeId.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.anyCredit}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.anyCredit.perKey]}
                />
                <ProTextInput {...defaultFormProps} {...formConfig.rti} permission={employeeApprenticeInfo.fieldPerObj[formConfig.rti.perKey]} />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.apprenticeStatusTypeId}
                  options={apprenticeStatus}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.apprenticeStatusTypeId.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.apprenticeshipRegNumber}
                  permission={employeeApprenticeInfo.fieldPerObj[formConfig.apprenticeshipRegNumber.perKey]}
                />
              </FormSectionWrapper>
            )}
            {employeeAddressInfo.canView && (
              <FormSectionWrapper title={"ADDRESS INFORMATION"}>
                <ProTextInput {...defaultFormProps} {...formConfig.address} permission={employeeAddressInfo.fieldPerObj[formConfig.address.perKey]} />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.address2}
                  permission={employeeAddressInfo.fieldPerObj[formConfig.address2.perKey]}
                />
                <ProTextInput {...defaultFormProps} {...formConfig.city} permission={employeeAddressInfo.fieldPerObj[formConfig.city.perKey]} />
                <ProTextInput {...defaultFormProps} {...formConfig.state} permission={employeeAddressInfo.fieldPerObj[formConfig.state.perKey]} />
                <ZipField {...defaultFormProps} {...formConfig.zip} permission={employeeAddressInfo.fieldPerObj[formConfig.zip.perKey]} />
              </FormSectionWrapper>
            )}
            {employeeMailingAddressInfo.canView && (
              <FormSectionWrapper title={"MAILING ADDRESS INFORMATION"}>
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.mailingAddress}
                  permission={employeeMailingAddressInfo.fieldPerObj[formConfig.mailingAddress.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.mailingState}
                  permission={employeeMailingAddressInfo.fieldPerObj[formConfig.mailingState.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.mailingCity}
                  permission={employeeMailingAddressInfo.fieldPerObj[formConfig.mailingCity.perKey]}
                />
                <ProTextInput
                  {...defaultFormProps}
                  {...formConfig.mailingZip}
                  permission={employeeMailingAddressInfo.fieldPerObj[formConfig.mailingZip.perKey]}
                />
              </FormSectionWrapper>
            )}
            {employeeAdditionalInfo.canView && (
              <FormSectionWrapper title={"ADDITIONAL INFORMATION"}>
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.fringePaymentMethodType}
                  options={fringePaymentMethod}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.fringePaymentMethodType.perKey]}
                />
                <ProCurrencyField
                  {...defaultFormProps}
                  {...formConfig.hourlyRateAmount}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.hourlyRateAmount.perKey]}
                />
                <ProCurrencyField
                  {...defaultFormProps}
                  {...formConfig.fringeRateAmount}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.fringeRateAmount.perKey]}
                />
                <ProDateField
                  {...defaultFormProps}
                  {...formConfig.startDate}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.startDate.perKey]}
                />
                <ProDateField
                  {...defaultFormProps}
                  {...formConfig.endDate}
                  fieldProps={{ minDate: watch("startDate") }}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.endDate.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.manager}
                  options={managerType}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.manager.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.languageType}
                  options={languageType}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.languageType.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.notificationType}
                  options={notificationType}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.notificationType.perKey]}
                />
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.employmentTermTypeId}
                  options={employeeTermType}
                  permission={employeeAdditionalInfo.fieldPerObj[formConfig.employmentTermTypeId.perKey]}
                />
                <ToggleField {...defaultFormProps} {...formConfig.isUnion} permission={employeeAdditionalInfo} />
              </FormSectionWrapper>
            )}

            {!isUnion && (
              <FormSectionWrapper title={"FRINGE BENEFITS (NON-UNION)"}>
                <ProSelectField
                  {...defaultFormProps}
                  {...formConfig.healthInsuranceId}
                  options={healthInsuranceOptions}
                  permission={fieldTruePermission}
                />
                <ProMultiSelectSelectField
                  {...defaultFormProps}
                  {...formConfig.retirementPensionId}
                  options={retirementPensionOptions.filter(option => isOptionNotSelected(option, retirementPension))}
                  permission={fieldTruePermission}
                  value={Array.isArray(retirementPension) ? Array.from(new Map(retirementPension.map(item => [item.value, item])).values()) : []}
                  onChange={selectedValues => {
                    const uniqueValues = Array.from(new Map(selectedValues.map(item => [item.value, item])).values());
                    setValue("retirementPensionId", uniqueValues);
                    handleRetirementPensionSelect(uniqueValues);
                  }}
                />
                <InputWrapper size={4}></InputWrapper>
                <Box display="flex" flexDirection="row" flexWrap="nowrap" gap={1} bgcolor="#f5f5f5" p={1} m={2} borderRadius={1} width="100%">
                  {fringeBenefitCheckbox?.map((checkbox, index) => (
                    <ProCheckbox
                      fieldProps={{
                        checked: checkbox?.employeeFringeBenefitAccounts[0]?.isSelected || false,
                        onChange: e => handleCheckBoxChange(e, index)
                      }}
                      control={control}
                      formValues={{
                        [`checkbox${index + 1}`]: checkbox?.employeeFringeBenefitAccounts[0]?.isSelected || false
                      }}
                      name={`checkbox${index + 1}`}
                      label={checkbox?.employeeFringeBenefitAccounts[0].planName}
                      permission={fieldTruePermission}
                    />
                  ))}
                </Box>
              </FormSectionWrapper>
            )}
          </>
        ) : (
          <Loading></Loading>
        )}
      </ProFormsLayout>
      <ConfirmationModal
        {...employeeTypeChangeModalConfig}
        confirmBtnText={"Confirm"}
        onConfirm={handleSubmit(values => {
          setEmployeeTypeChangeModalConfig({ show: false, message: "" });
          onSubmit({ ...values, passEmployeeTypeCheck: true });
        })}
        onCancel={() => setEmployeeTypeChangeModalConfig({ show: false, message: "" })}
      />
    </div>
  );
}
